import { GatewayCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/outputs/gateway-customer.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { CustomerListHolderEmailCell } from './customer-list-holder-email.cell';
import { CustomerListHolderEmailHeader } from './customer-list-holder-email.header';

export const CustomerListHolderEmailColumn: IdentifiedColumnDef<
  GatewayCustomerModel,
  NonNullable<GatewayCustomerModel['holder']>['email'] | undefined
> = {
  id: 'holderEmail',
  enableSorting: false,
  header: CustomerListHolderEmailHeader,
  cell: CustomerListHolderEmailCell,
};
